import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { IDatasource, Query } from 'utility-ts-orm';
import { Schedule } from '../builders/schedule_builder';
import { ScheduleSection } from '../builders/schedule_section_builder';

export class ScheduleQuery implements IQuery {
  private _result: Schedule;
  private _studentEnrolledStrings: string[];
  _term: any;

  constructor(private DisplayDataBuilder: any, private ngScheduleDatastore: IDatasource<Schedule>) {
    Query.registerQuery(this, ngScheduleDatastore);
    this._studentEnrolledStrings = ['REGISTERED', 'IN_PROGRESS', 'COMPLETED'];
  }

  run(): this {
    const schedule: Schedule = _4.first(this.ngScheduleDatastore.query((schedule: Schedule) => true));

    if (_4.isEmpty(schedule)) {
      this._result = {} as Schedule;
      return this;
    }

    _4.each(schedule.section_time, (section_time: any) => {
      section_time._location =
        _4.find(schedule.location, (location: any) => section_time.location === location.id) || '';
    });

    _4.each(schedule.section, (section: any) => {
      section._sectionTime = _4.sortBy(
        _4.filter(schedule.section_time as any, (section_time: any) => section_time.section === section.id),
        (section_time: any) => section_time.day_of_week
      );
      section._course = _4.find(schedule.course as any, (course: any) => section.course === course.id);
      section._sectionLabels = _4.find(
        schedule.section_labels as any,
        (section_labels: any) => section_labels.id === section.id
      );
      section._displayData = this.DisplayDataBuilder.buildDisplayData(section._sectionTime);
    });

    this._result = schedule;
    return this;
  }

  get model() {
    return this._result;
  }

  get result() {
    return this._result;
  }

  get currentTerm() {
    const now = moment();
    return _4.find(this.result.term, (term) => now.isBetween(term.term_start_dt, term.term_end_dt, 'day', '[]'));
  }

  isCurrentTerm(termId: number): boolean {
    return this.currentTerm && this.currentTerm.id === termId;
  }

  reset() {
    this._result = {} as Schedule;
    this._term = undefined;
  }

  getSections() {
    return this._result.section;
  }

  getTerms() {
    return _4.sortBy(this._result.term, (term: any) => term.term_start_dt.format('X'));
  }

  getTermText(termId: number): string {
    const term = _4.find(this._result.term, (resultTerm: any) => resultTerm.id === termId);
    return _4.isEmpty(term) ? '' : term.name;
  }

  getSectionsByTerm(termId: number) {
    return _4.filter(this._result.section as any, (section: ScheduleSection) => section.term === termId);
  }

  isRegisteredCourse(section: ScheduleSection): boolean {
    return this._studentEnrolledStrings.includes(this._result.section_status[section.id].status);
  }

  getCourseDetail(id: string) {
    return _4.find(this._result.section as any, (section: ScheduleSection) => section.id === parseInt(id, 10));
  }

  getTemporalSections() {
    return _4.filter(this._result.section as any, (section: ScheduleSection) => !this.courseIsNotPhysical(section));
  }

  getTemporalSectionsByTerm(termID: number) {
    return _4.filter(this.getSectionsByTerm(termID), (section: any) => !this.courseIsNotPhysical(section));
  }

  courseIsNotPhysical(course: any) {
    /* tslint:disable */
    return _4.isEmpty(course._sectionTime) || (_4.first(course._sectionTime) as any).day_of_week === 8;
    /* tslint:enable */
  }

  setPersistantTerm(termId: number) {
    this._term = termId;
    return this._term;
  }

  getPersistantTerm() {
    return this._term;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/queries/schedule_query.ts